import type { ReactNode } from 'react';

/**
 * The text of a button. `.btn` keeps it on one line; this lets it give way first
 * once the button reaches its container's width, ending in an ellipsis. Outside a
 * `.btn` (LinkLabel in a navigation link) it is a plain span.
 */
export function UiButtonLabel({ children }: { children: ReactNode }) {
    return <span className="in-[.btn]:min-w-0 in-[.btn]:truncate">{children}</span>;
}
